// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comparison-link[data-v-45e2076e]{color:var(--c-black);display:inline-block;min-height:50px;width:100%}.comparison-link .button[data-v-45e2076e]{border:0;color:var(--c-original-green);font-weight:700;height:25px;justify-content:flex-start;min-height:25px;padding:0}.comparison-modal[data-v-45e2076e]{padding:15px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
